import { useDispatch, useSelector } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { userSlice } from "./userSlice";
import { pageTitleSlice } from "./pageTitleSlice";
import { loanIntelligenceSlice } from "./loanIntelligence";

const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    pageTitle: pageTitleSlice.reducer,
    loanIntelligence: loanIntelligenceSlice.reducer,
  },
});
export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
